// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'
import router from './router'
import ElementUI from 'element-ui'
import MetaInfo from 'vue-meta-info'
import VueAgile from 'vue-agile'
import _ from "lodash";
import Vuex from 'vuex'
import store from './store'
import VueCarousel from 'vue-carousel'
import SocialSharing from 'vue-social-sharing'
import Lightbox from 'vue-easy-lightbox'

import vueEventCalendar from 'vue-event-calendar'
Vue.use(vueEventCalendar, { locale: 'zh', color: '#01b6e2' }) //locale can be 'zh' , 'en' , 'es', 'pt-br', 'ja', 'ko', 'fr', 'it', 'ru', 'de', 'vi', 'ua'
import 'vue-event-calendar/dist/style.css' //^1.1.10, CSS has been extracted as one file, so you can easily update it.

import 'element-ui/lib/theme-chalk/index.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'




import App from './App'

Vue.prototype._ = _
Vue.use(ElementUI)
Vue.use(MetaInfo)
Vue.use(BootstrapVue)
Vue.use(VueAgile)
Vue.use(Vuex)
Vue.use(VueCarousel)
Vue.use(SocialSharing);
Vue.use(Lightbox)
Vue.config.productionTip = false

require("./scss/align.scss");
require("./scss/rwd.scss");

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js